import Vue from 'vue';
import studyDetails from '@/components/pages/AdminHomePage/studies/studyDetails/studyDetails.vue'

Vue.component('studydetails', studyDetails);
